import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { ContactDetails, ContactResponse, ContactListResponse, CLPUserOffice, CLPContactSOInventionResponse, CLPContactSOInvention } from '../models/contact.model';
import { delayedRetryHttp } from '../shared/delayedRetry';
import { UtilityService } from './shared/utility.service';


@Injectable()
export class ContactService {
    private baseUrl: string;
    private api: string = "api/Contact";

    constructor(private httpClient: HttpClient, @Inject('BASE_URL') _baseUrl: string, private _utilityService: UtilityService) {
        this.baseUrl = _baseUrl + this.api;
    }

    private handleErrors(errorResponse: HttpErrorResponse) {
        if (errorResponse.error instanceof ErrorEvent) {
            console.error('Contact Service Client Side Error: ', errorResponse.error.message);
        } else {
            throw errorResponse;
        }
    }

    async getContactAsync(encryptedUser: string, contactId: number): Promise<ContactResponse | void> {
        const a = await this.httpClient
            .get<ContactResponse>(`${this.baseUrl}/GetContact/${contactId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "contactId - " + contactId, encryptedUser, "ContactService", "getContactAsync"); });

        return a;
    }

    async getContactStateAsync(encryptedUser: string, contactId: number): Promise<ContactResponse | void> {
        const a = await this.httpClient
            .get<ContactResponse>(`${this.baseUrl}/GetContactState/${contactId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "contactId - " + contactId, encryptedUser, "ContactService", "getContactStateAsync"); });

        return a;
    }

    async getContact_EmailAsync(encryptedUser: string, email: string): Promise<ContactResponse | void> {
        const a = await this.httpClient
            .get<ContactResponse>(`${this.baseUrl}/GetContact_LoadByEmail/${email}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "email - " + email, encryptedUser, "ContactService", "getContact_EmailAsync"); });

        return a;
    }

    async getContact_CellAsync(encryptedUser: string, cell: string): Promise<ContactResponse | void> {
        const a = await this.httpClient
            .get<ContactResponse>(`${this.baseUrl}/GetContact_LoadByMobile/${cell}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "cell - " + cell, encryptedUser, "ContactService", "getContact_CellAsync"); });

        return a;
    }

    async updateContactAsync(encryptedUser: string, contactDetails: ContactDetails): Promise<ContactResponse | void> {
        const a = await this.httpClient.post<ContactResponse>(`${this.baseUrl}/UpdateContact`, contactDetails, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + encryptedUser
            })
        }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, contactDetails, "", "ContactService", "updateContactAsync"); });

        return a;
    }

    async createContactAsync(encryptedUser: string, contactDetails: ContactDetails): Promise<ContactResponse | void> {
        const a = await this.httpClient.post<ContactResponse>(`${this.baseUrl}`, contactDetails, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + encryptedUser
            })
        }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, contactDetails, "", "ContactService", "createContactAsync"); });


        return a;
    }

    async getContactDetailsAsync(encryptedUser: string, clpUserId: number): Promise<ContactListResponse | void> {
        const a = await this.httpClient
            .get<ContactListResponse>(`${this.baseUrl}/GetContactList/${clpUserId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "clpUserId - " + clpUserId, "ContactService", "getContactDetailsAsync"); });


        return a;
    }

    async getContactSearchListAsync(encryptedUser: string, searchText: string, clpUserId: number): Promise<ContactListResponse | void> {
        const a = await this.httpClient
            .get<ContactListResponse>(`${this.baseUrl}/GetContact_SearchList/${searchText}/${clpUserId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "searchText - " + searchText + " clpUserId - " + clpUserId, "ContactService", "getContactSearchListAsync"); });


        return a;
    }

    async getOfficeByUserId(encryptedUser: string, clpUserId: number): Promise<CLPUserOffice | void> {
        const a = await this.httpClient
            .get<CLPUserOffice>(`${this.baseUrl}/GetOfficeByUserId/${clpUserId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "clpUserId - " + clpUserId, "ContactService", "getOfficeByUserId"); });


        return a;
    }

    async updateContactInSalesOptimaAsync(encryptedUser: string, contactDetails: CLPContactSOInvention): Promise<CLPContactSOInventionResponse | void> {
        const a = await this.httpClient.post<CLPContactSOInventionResponse>(`${this.baseUrl}/UpdateContactInSalesOptima`, contactDetails, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + encryptedUser
            })
        }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, contactDetails, "", "ContactService", "updateContactInSalesOptimaAsync"); });

        return a;
    }
}
